import { render, staticRenderFns } from "./gradeResult.vue?vue&type=template&id=515058b4&"
import script from "./gradeResult.vue?vue&type=script&lang=js&"
export * from "./gradeResult.vue?vue&type=script&lang=js&"
import style0 from "./gradeResult.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports